// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5239) return "static/chunks/5239-6162a4c300400f33.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"606":"1ef22c877dd42580","4905":"d044e07566153138"}[chunkId] + ".js";
};